module.exports = __webpack_public_path__ + "docs/intro-8ab389.md";